export default "__VITE_ASSET__CqaqsjZe__"